export const SET_ENTITY_DATA = 'SET_ENTITY_DATA';
export function setEntityData(entity, data) {
  return {
    type: SET_ENTITY_DATA,
    entity,
    data,
  };
}

export const DELETE_ENTITY_DATA = 'DELETE_ENTITY_DATA';
